import { render, staticRenderFns } from "./MixinCell.vue?vue&type=template&id=020c0945&scoped=true"
import script from "./MixinCell.vue?vue&type=script&lang=js"
export * from "./MixinCell.vue?vue&type=script&lang=js"
import style0 from "./MixinCell.vue?vue&type=style&index=0&id=020c0945&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020c0945",
  null
  
)

export default component.exports